export default __webpack_public_path__ + "static/media/logo_talken_blue.84e6a9aa.svg";